
import ShoppingCart from '../mixins/shopping-cart'

export default {
  mixins: [ShoppingCart],
  watch: {
    cartStale(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.updateCart()
      }
    }
  },
  computed: {
    items() {
      return this.cartData.items || []
    },
    summary() {
      return {
        subtotal: this.cartData.subtotal,
        taxes: this.cartData.taxes,
        // TODO: Remove fallback to total
        total: this.cartData.itemsTotal || this.cartData.total
      }
    },
    paymentSummary() {
      return {
        subtotal: this.cartData.subtotal,
        taxes: this.cartData.taxes,
        shippingCost: this.cartData.shippingCost,
        paymentCost: this.cartData.paymentCost,
        paymentInterest: this.cartData.paymentInterest,
        total: this.cartData.total
      }
    },
    checkout() {
      return Boolean(this.items.length)
    }
  },
  mounted() {
    if (this.cartStale) {
      this.updateCart()
    }
  },
  render() {
    if (this.$scopedSlots && this.$scopedSlots.default) {
      return this.$scopedSlots.default({
        cart: this.cartData,
        items: this.items,
        summary: this.summary,
        paymentSummary: this.paymentSummary,
        updateCart: this.updateCart,
        checkout: this.checkout
      })
    }

    return null
  }
}
